<div class="top-nav-container">
  <div class="top-nav-content">
    <div class="logo-container">
      <img
        [src]="environment.cloudFrontUrl + '/brand/TDOT-Logo.png'"
        alt="Tennessee Department of Transportation logo"
        class="top-nav-logo"
        />
        <img
          [src]="environment.cloudFrontUrl + '/brand/I-24-CL-Logo.png'"
          alt="Tennessee Department of Transportation logo"
          class="top-nav-logo choice-lanes-logo"
          />
        </div>
        <button
          class="top-nav-menu"
          aria-controls="dropdown-menu"
          [attr.aria-expanded]="isMenuOpen"
          aria-haspopup="true"
          tabindex="0"
          (click)="toggleMenu()"
          (keydown)="handleMenuKeydown($event)"
          aria-label="Toggle menu"
          >
          <mat-icon>menu</mat-icon>
        </button>

        @if (isMenuOpen) {
          <div
            class="dropdown-menu"
            id="dropdown-menu"
            [ngClass]="{ open: isMenuOpen }"
            role="menu"
            >
            <ul>
              @for (page of pages; track page; let i = $index) {
                <li
                  role="menuitem"
          [ngStyle]="
            pageIndex === i
              ? {
                  color: '#EE3124',
                  'background-color': 'white',
                  'border-radius': '10px'
                }
              : { color: '#FFFFFF' }
          "
                tabindex="0"
                (click)="setPageIndex(i)"
                (keydown)="handleItemKeydown($event, i)"
                [attr.aria-current]="pageIndex === i ? 'page' : null"
                >
                {{ page }}
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
